import { Component, Input } from '@angular/core';
import { OriginalFare } from 'src/app/core/models/cancellation.model';
import { ExchangeFare } from 'src/app/core/models/voluntary-change.model';

@Component({
  selector: 'app-exchange-fare',
  templateUrl: './exchange-fare.component.html',
  styleUrls: ['./exchange-fare.component.scss']
})
export class ExchangeFareComponent {
  @Input() isPrivate: boolean;
  @Input() tourCode: string;
  @Input() original: OriginalFare;
  @Input() exchangeFare: ExchangeFare;
}
